import React from 'react';
import {
    Tooltip,
    ResponsiveContainer,
    PieChart,
    Pie,
    Cell,
    Legend,
  } from 'recharts';
import { Card, CardContent } from "../../../components/ui/card";
import constants from '../../../commonUtils/constants';


const SourceTypeDist = ({ data }) => {

    return (
        <>
            <Card className="shadow-md rounded-2xl">
                <CardContent>
                    <h2 className="text-lg font-bold mb-4">Source Type Distribution</h2>
                    <ResponsiveContainer width="100%" height={250}>
                    <PieChart>
                        <Pie
                            data={data}
                            dataKey="value"
                            nameKey="name"
                            cx="50%"
                            cy="50%"
                            innerRadius={40}
                            outerRadius={80}
                            fill={constants.dashboard.colors[0]}
                            label
                        >
                            {Array.isArray(data) &&
                            data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={constants.dashboard.colors[index]} />
                            ))}
                        </Pie>
                        <Tooltip />
                        <Legend />
                    </PieChart>
                    </ResponsiveContainer>
                </CardContent>
            </Card>
        </>
    );
};

export default SourceTypeDist;
